// import React, { useState, useEffect } from 'react';
// import { Search, Calendar, DollarSign, Users, RefreshCw, Download, Check, CheckCircle, ChevronDown, ChevronRight, Eye, Package } from 'lucide-react';
// // Add Firebase imports
// import { db } from '../firebase'; // Adjust path as needed
// import { doc, setDoc, getDoc, collection, serverTimestamp, Timestamp } from 'firebase/firestore';

// const CODRemittanceTable = () => {
//   const [remittances, setRemittances] = useState([]);
//   const [expandedRemittances, setExpandedRemittances] = useState(new Set());
//   const [remittanceUserData, setRemittanceUserData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [loadingRemittances, setLoadingRemittances] = useState(new Set());
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortConfig, setSortConfig] = useState({ key: 'netPayableAmount', direction: 'desc' });
//   const [confirmingIds, setConfirmingIds] = useState(new Set());
//   const [unconfirmedStatus, setUnconfirmedStatus] = useState({});
// const [loadingUnconfirmedStatus, setLoadingUnconfirmedStatus] = useState(false);
// const [showPendingOnly, setShowPendingOnly] = useState(false);
// const [pendingRemittancesCount, setPendingRemittancesCount] = useState(0);
// const [checkingPendingRemittances, setCheckingPendingRemittances] = useState(false);
// const [pendingRemittanceIds, setPendingRemittanceIds] = useState(new Set());

//   // API configuration
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/codRemittance';

//   // Helper function to format date as string (YYYY-MM-DD)
//   const formatDateString = (dateInput) => {
//     if (dateInput === null || dateInput === undefined) {
//       return '';
//     }

//     let dateStr;
//     try {
//       dateStr = String(dateInput);
//     } catch (e) {
//       console.error('Error converting to string:', e);
//       return '';
//     }

//     console.log('Safe string conversion:', dateStr);

//     try {
//       let parts = [];
//       let currentPart = '';

//       for (let i = 0; i < dateStr.length; i++) {
//         const char = dateStr.charAt(i);
//         if (char === ' ') {
//           if (currentPart.length > 0) {
//             parts.push(currentPart);
//             currentPart = '';
//           }
//         } else {
//           currentPart += char;
//         }
//       }
//       if (currentPart.length > 0) {
//         parts.push(currentPart);
//       }

//       console.log('Manual parsing result:', parts);

//       if (parts.length === 3) {
//         const dayStr = parts[0];
//         const monthStr = parts[1];
//         const yearStr = parts[2];

//         const day = parseInt(dayStr, 10);
//         const year = parseInt(yearStr, 10);

//         let monthNum = 0;
//         if (monthStr === 'Jan') monthNum = 1;
//         else if (monthStr === 'Feb') monthNum = 2;
//         else if (monthStr === 'Mar') monthNum = 3;
//         else if (monthStr === 'Apr') monthNum = 4;
//         else if (monthStr === 'May') monthNum = 5;
//         else if (monthStr === 'Jun') monthNum = 6;
//         else if (monthStr === 'Jul') monthNum = 7;
//         else if (monthStr === 'Aug') monthNum = 8;
//         else if (monthStr === 'Sep') monthNum = 9;
//         else if (monthStr === 'Oct') monthNum = 10;
//         else if (monthStr === 'Nov') monthNum = 11;
//         else if (monthStr === 'Dec') monthNum = 12;

//         if (monthNum > 0 && day > 0 && day <= 31 && year > 1900 && year < 2100) {
//           const yearPadded = year.toString();
//           const monthPadded = (monthNum < 10) ? '0' + monthNum.toString() : monthNum.toString();
//           const dayPadded = (day < 10) ? '0' + day.toString() : day.toString();

//           const result = yearPadded + '-' + monthPadded + '-' + dayPadded;
//           console.log('Manual date formatting result:', result);
//           return result;
//         }
//       }

//       const cleanDateStr = dateStr.trim();
//       const testDate = new Date(cleanDateStr);

//       if (!isNaN(testDate.getTime())) {
//         const isoString = testDate.toISOString();
//         let datePart = '';
//         for (let i = 0; i < 10; i++) {
//           datePart += isoString.charAt(i);
//         }
//         console.log('Date object parsing result:', datePart);
//         return datePart;
//       }

//     } catch (error) {
//       console.error('Error in formatDateString:', error, 'Input was:', dateInput);
//     }

//     return '';
//   };

//   // Bulletproof timestamp conversion
//   const convertToTimestamp = (dateInput) => {
//     if (dateInput === null || dateInput === undefined) {
//       return null;
//     }

//     try {
//       if (typeof dateInput === 'object' && dateInput !== null && 
//           typeof dateInput.seconds === 'number') {
//         return dateInput;
//       }

//       if (dateInput instanceof Date && !isNaN(dateInput.getTime())) {
//         return Timestamp.fromDate(dateInput);
//       }

//       const dateStr = String(dateInput);
//       let parts = [];
//       let currentPart = '';

//       for (let i = 0; i < dateStr.length; i++) {
//         const char = dateStr.charAt(i);
//         if (char === ' ') {
//           if (currentPart.length > 0) {
//             parts.push(currentPart);
//             currentPart = '';
//           }
//         } else {
//           currentPart += char;
//         }
//       }
//       if (currentPart.length > 0) {
//         parts.push(currentPart);
//       }

//       if (parts.length === 3) {
//         const dayStr = parts[0];
//         const monthStr = parts[1];
//         const yearStr = parts[2];

//         const day = parseInt(dayStr, 10);
//         const year = parseInt(yearStr, 10);

//         let monthNum = -1;
//         if (monthStr === 'Jan') monthNum = 0;
//         else if (monthStr === 'Feb') monthNum = 1;
//         else if (monthStr === 'Mar') monthNum = 2;
//         else if (monthStr === 'Apr') monthNum = 3;
//         else if (monthStr === 'May') monthNum = 4;
//         else if (monthStr === 'Jun') monthNum = 5;
//         else if (monthStr === 'Jul') monthNum = 6;
//         else if (monthStr === 'Aug') monthNum = 7;
//         else if (monthStr === 'Sep') monthNum = 8;
//         else if (monthStr === 'Oct') monthNum = 9;
//         else if (monthStr === 'Nov') monthNum = 10;
//         else if (monthStr === 'Dec') monthNum = 11;

//         if (monthNum >= 0 && day > 0 && day <= 31 && year > 1900 && year < 2100) {
//           const date = new Date(year, monthNum, day);
//           if (!isNaN(date.getTime())) {
//             return Timestamp.fromDate(date);
//           }
//         }
//       }

//       const testDate = new Date(dateStr.trim());
//       if (!isNaN(testDate.getTime())) {
//         return Timestamp.fromDate(testDate);
//       }

//     } catch (error) {
//       console.error('Error in convertToTimestamp:', error, 'Input was:', dateInput);
//     }

//     return null;
//   };

//   // Function to check Firestore confirmation status for users in a remittance
//   const checkFirestoreConfirmationStatus = async (userSummaries, remittanceId) => {
//     console.log('Checking Firestore confirmation status for remittance', remittanceId);

//     const updatedUsers = await Promise.all(
//       userSummaries.map(async (user) => {
//         try {
//           const userIdStr = String(user.userId);
//           const remittanceIdStr = String(remittanceId);

//           // Check if this remittance exists in codSummary collection
//           const codSummaryRef = doc(db, 'users', userIdStr, 'codSummary', remittanceIdStr);
//           const codSummaryDoc = await getDoc(codSummaryRef);

//           if (codSummaryDoc.exists()) {
//             const data = codSummaryDoc.data();
//             const isConfirmed = data.status === 'confirmed';
//             console.log(`Remittance ${remittanceIdStr} for user ${userIdStr}: ${isConfirmed ? 'CONFIRMED' : 'NOT CONFIRMED'}`);
//             return { ...user, confirmed: isConfirmed };
//           } else {
//             console.log(`No Firestore record found for remittance ${remittanceIdStr} user ${userIdStr}`);
//             return { ...user, confirmed: false };
//           }
//         } catch (error) {
//           console.error(`Error checking Firestore status for user ${user.userId}, remittance ${remittanceId}:`, error);
//           return { ...user, confirmed: false };
//         }
//       })
//     );

//     return updatedUsers;
//   };


//   // Function to check all remittances for pending confirmations
// const checkAllRemittancesForPending = async () => {
//     setCheckingPendingRemittances(true);
//     const pendingIds = new Set();

//     try {
//       // Process remittances in batches to avoid overwhelming the API
//       const batchSize = 5;
//       for (let i = 0; i < remittances.length; i += batchSize) {
//         const batch = remittances.slice(i, i + batchSize);

//         await Promise.all(
//           batch.map(async (remittance) => {
//             // Skip if already loaded
//             if (remittanceUserData[remittance.id]) {
//               const userData = remittanceUserData[remittance.id];
//               const hasUnconfirmed = userData.userSummaries?.some(user => !user.confirmed);
//               if (hasUnconfirmed && remittance.paymentStatus === 'PAID') {
//                 pendingIds.add(remittance.id);
//               }
//               return;
//             }

//             // Only check PAID remittances
//             if (remittance.paymentStatus !== 'PAID') return;

//             try {
//               const response = await fetch(
//                 `${API_BASE_URL}/api/cod-remittance/${remittance.id}/user-summary`,
//                 {
//                   method: 'GET',
//                   headers: {
//                     'Content-Type': 'application/json',
//                   }
//                 }
//               );

//               if (!response.ok) return;

//               const data = await response.json();

//               if (data.success && data.data) {
//                 const usersWithConfirmation = await checkFirestoreConfirmationStatus(
//                   data.data.userSummaries,
//                   remittance.id
//                 );

//                 // Store in state
//                 setRemittanceUserData(prev => ({
//                   ...prev,
//                   [remittance.id]: {
//                     ...data.data,
//                     userSummaries: usersWithConfirmation
//                   }
//                 }));

//                 // Check if has unconfirmed users
//                 const hasUnconfirmed = usersWithConfirmation.some(user => !user.confirmed);
//                 if (hasUnconfirmed) {
//                   pendingIds.add(remittance.id);
//                 }
//               }
//             } catch (err) {
//               console.error(`Error checking remittance ${remittance.id}:`, err);
//             }
//           })
//         );
//       }

//       setPendingRemittanceIds(pendingIds);
//       setPendingRemittancesCount(pendingIds.size);
//     } catch (error) {
//       console.error('Error checking pending remittances:', error);
//     } finally {
//       setCheckingPendingRemittances(false);
//     }
//   };

//   // Update existing useEffect or add new one
// useEffect(() => {
//     if (remittances.length > 0 && !checkingPendingRemittances && pendingRemittanceIds.size === 0) {
//       checkAllRemittancesForPending();
//     }
//   }, [remittances]);

//   // Fetch initial remittances list
//   // const fetchRemittances = async () => {
//   //   setLoading(true);
//   //   try {
//   //     const response = await fetch(`${API_BASE_URL}/api/cod-remittances`, {
//   //       method: 'GET',
//   //       headers: {
//   //         'Content-Type': 'application/json',
//   //       }
//   //     });

//   //     if (!response.ok) {
//   //       throw new Error(`HTTP error! status: ${response.status}`);
//   //     }

//   //     const data = await response.json();

//   //     if (data.success && data.data && data.data.remittances) {
//   //       setRemittances(data.data.remittances);
//   //       setError(null);
//   //     } else {
//   //       throw new Error(data.message || 'Invalid API response format');
//   //     }
//   //   } catch (err) {
//   //     setError(`Failed to fetch remittances: ${err.message}`);
//   //     console.error('Error fetching remittances:', err);
//   //     setRemittances([]);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const fetchRemittances = async () => {
//     setLoading(true);
//     try {
//       // Change to use paginated endpoint
//       const response = await fetch(`${API_BASE_URL}/api/cod-remittances-paginated`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       if (data.success && data.data && data.data.remittances) {
//         setRemittances(data.data.remittances);
//         setError(null);
//       } else {
//         throw new Error(data.message || 'Invalid API response format');
//       }
//     } catch (err) {
//       setError(`Failed to fetch remittances: ${err.message}`);
//       console.error('Error fetching remittances:', err);
//       setRemittances([]);
//     } finally {
//       setLoading(false);
//     }
//   };

// // Add function to calculate pending remittances
// useEffect(() => {
//     const calculatePendingRemittances = () => {
//       let pendingCount = 0;

//       remittances.forEach(remittance => {
//         const userData = remittanceUserData[remittance.id];
//         if (userData && userData.userSummaries) {
//           const hasUnconfirmed = userData.userSummaries.some(user => !user.confirmed);
//           if (hasUnconfirmed && remittance.paymentStatus === 'PAID') {
//             pendingCount++;
//           }
//         }
//       });

//       setPendingRemittancesCount(pendingCount);
//     };

//     calculatePendingRemittances();
//   }, [remittances, remittanceUserData]);

//   // Fetch user summary for a specific remittance
//   const fetchRemittanceUserSummary = async (remittanceId) => {
//     if (remittanceUserData[remittanceId]) {
//       return; // Already loaded
//     }

//     setLoadingRemittances(prev => new Set([...prev, remittanceId]));

//     try {
//       const response = await fetch(`${API_BASE_URL}/api/cod-remittance/${remittanceId}/user-summary`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       if (data.success && data.data) {
//         // Check Firestore confirmation status
//         const usersWithConfirmation = await checkFirestoreConfirmationStatus(
//           data.data.userSummaries, 
//           remittanceId
//         );

//         setRemittanceUserData(prev => ({
//           ...prev,
//           [remittanceId]: {
//             ...data.data,
//             userSummaries: usersWithConfirmation
//           }
//         }));
//       } else {
//         throw new Error(data.message || 'Invalid API response format');
//       }
//     } catch (err) {
//       console.error(`Error fetching user summary for remittance ${remittanceId}:`, err);
//       // Still store empty data to prevent re-fetching
//       setRemittanceUserData(prev => ({
//         ...prev,
//         [remittanceId]: { userSummaries: [], summary: { totalUsers: 0, totalAmount: 0 } }
//       }));
//     } finally {
//       setLoadingRemittances(prev => {
//         const newSet = new Set(prev);
//         newSet.delete(remittanceId);
//         return newSet;
//       });
//     }
//   };

//   // Toggle remittance expansion
//   const toggleRemittanceExpansion = async (remittanceId) => {
//     const isExpanded = expandedRemittances.has(remittanceId);

//     if (isExpanded) {
//       // Collapse
//       setExpandedRemittances(prev => {
//         const newSet = new Set(prev);
//         newSet.delete(remittanceId);
//         return newSet;
//       });
//     } else {
//       // Expand and fetch data if needed
//       setExpandedRemittances(prev => new Set([...prev, remittanceId]));
//       await fetchRemittanceUserSummary(remittanceId);
//     }
//   };

//   // Initial data fetch
//   useEffect(() => {
//     fetchRemittances();
//   }, []);



//   const fetchUnconfirmedStatus = async () => {
//   setLoadingUnconfirmedStatus(true);
//   try {
//     const response = await fetch(`${API_BASE_URL}/api/cod-remittances/unconfirmed-status`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       }
//     });

//     if (response.ok) {
//       const data = await response.json();
//       if (data.success) {
//         setUnconfirmedStatus(data.data);
//       }
//     }
//   } catch (err) {
//     console.error('Error fetching unconfirmed status:', err);
//   } finally {
//     setLoadingUnconfirmedStatus(false);
//   }
// };

// // Update useEffect to fetch unconfirmed status
// useEffect(() => {
//   const loadData = async () => {
//     await fetchRemittances();
//     await fetchUnconfirmedStatus();
//   };
//   loadData();
// }, []);

// // Update refreshData function


//   // Filter remittances based on search term
//   // const filteredRemittances = remittances.filter(remittance =>
//   //   remittance.id.toString().includes(searchTerm) ||
//   //   remittance.paymentDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
//   //   remittance.paymentStatus.toLowerCase().includes(searchTerm.toLowerCase())
//   // );

// const filteredRemittances = remittances.filter(remittance => {
//     const matchesSearch = remittance.id.toString().includes(searchTerm) ||
//       remittance.paymentDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       remittance.paymentStatus.toLowerCase().includes(searchTerm.toLowerCase());

//     if (!matchesSearch) return false;

//     if (showPendingOnly) {
//       return pendingRemittanceIds.has(remittance.id);
//     }

//     return true;
//   });

//   // Sort remittances
//   const sortedRemittances = [...filteredRemittances].sort((a, b) => {
//     if (sortConfig.key === 'netPayableAmount' || sortConfig.key === 'generatedCod') {
//       return sortConfig.direction === 'asc' 
//         ? a[sortConfig.key] - b[sortConfig.key] 
//         : b[sortConfig.key] - a[sortConfig.key];
//     }
//     if (sortConfig.key === 'paymentDate') {
//       return sortConfig.direction === 'asc' 
//         ? new Date(a.paymentDate) - new Date(b.paymentDate)
//         : new Date(b.paymentDate) - new Date(a.paymentDate);
//     }
//     if (sortConfig.key === 'id') {
//       return sortConfig.direction === 'asc' 
//         ? a.id - b.id
//         : b.id - a.id;
//     }
//     return 0;
//   });

//   const handleSort = (key) => {
//     setSortConfig(prevConfig => ({
//       key,
//       direction: prevConfig.key === key && prevConfig.direction === 'desc' ? 'asc' : 'desc'
//     }));
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 2
//     }).format(amount);
//   };

//   const formatDate = (dateString) => {
//     if (dateString === '--' || !dateString) return dateString;
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

// const handleConfirm = async (remittanceId, userId) => {
//   const userIdStr = String(userId);
//   const remittanceIdStr = String(remittanceId);

//   console.log('ID Conversion:', {
//     original: { remittanceId, userId },
//     converted: { remittanceIdStr, userIdStr }
//   });

//   setConfirmingIds(prev => new Set([...prev, `${remittanceIdStr}_${userIdStr}`]));

//   try {
//     const remittanceData = remittanceUserData[remittanceIdStr];
//     if (!remittanceData) {
//       throw new Error('Remittance data not found');
//     }

//     const userRemittanceData = remittanceData.userSummaries.find(user => 
//       String(user.userId) === userIdStr
//     );

//     if (!userRemittanceData) {
//       throw new Error('User remittance data not found');
//     }

//     if (!userRemittanceData.paymentDate || userRemittanceData.paymentDate === '--') {
//       throw new Error('Invalid payment date for this remittance');
//     }

//     if (!userRemittanceData.orders || userRemittanceData.orders.length === 0) {
//       throw new Error('No orders found for this remittance');
//     }

//     const formattedDate = formatDateString(userRemittanceData.paymentDate);
//     if (!formattedDate) {
//       throw new Error(`Could not format payment date: ${userRemittanceData.paymentDate}`);
//     }

//     const orderTimestamp = convertToTimestamp(userRemittanceData.paymentDate);

//     // 1. Store in codSummary collection
//     const codSummaryRef = doc(db, 'users', userIdStr, 'codSummary', remittanceIdStr);
//     const codSummaryData = {
//       date: formattedDate,
//       lastUpdated: serverTimestamp(),
//       orderCount: userRemittanceData.orderCount,
//       orders: userRemittanceData.orders.map(order => String(order.referenceId || order.orderId)),
//       status: "confirmed",
//       timestamp: serverTimestamp(),
//       totalAmount: userRemittanceData.totalAmount
//     };

//     await setDoc(codSummaryRef, codSummaryData);

//     // 2. Store each order in codRecords collection
//     const codRecordsPromises = userRemittanceData.orders.map(async (order) => {
//       if (!order.referenceId && !order.orderId) {
//         console.warn('Order missing both referenceId and orderId:', order);
//         return Promise.resolve();
//       }

//       const orderIdStr = String(order.referenceId || order.orderId);
//       const codRecordRef = doc(db, 'users', userIdStr, 'codRecords', orderIdStr);
//       const codRecordData = {
//         amount: parseFloat(order.codAmount) || 0,
//         date: formattedDate,
//         orderId: String(order.referenceId),
//         remittanceId: remittanceIdStr,
//         timestamp: orderTimestamp || serverTimestamp()
//       };

//       return setDoc(codRecordRef, codRecordData);
//     });

//     await Promise.all(codRecordsPromises);

//     // 3. **NEW: Update each order document with COD remittance info**
//     const orderUpdatePromises = userRemittanceData.orders.map(async (order) => {
//       if (!order.referenceId && !order.orderId) {
//         console.warn('Order missing both referenceId and orderId:', order);
//         return Promise.resolve();
//       }

//       const orderIdStr = String(order.referenceId || order.orderId);
//       const orderRef = doc(db, 'users', userIdStr, 'orders', orderIdStr);

//       const orderUpdateData = {
//         codRemittance: true,
//         codRemittanceId: remittanceIdStr,
//         codRemittanceDate: formattedDate,
//         codRemittanceAmount: parseFloat(order.codAmount) || 0,
//         codRemittanceConfirmedAt: serverTimestamp()
//       };

//       return setDoc(orderRef, orderUpdateData, { merge: true });
//     });

//     await Promise.all(orderUpdatePromises);

//     // Update local state to mark as confirmed
//     setRemittanceUserData(prev => ({
//       ...prev,
//       [remittanceIdStr]: {
//         ...prev[remittanceIdStr],
//         userSummaries: prev[remittanceIdStr].userSummaries.map(user => 
//           String(user.userId) === userIdStr
//             ? { ...user, confirmed: true }
//             : user
//         )
//       }
//     }));

//     console.log('Successfully confirmed remittance and stored data in Firestore');

//   } catch (error) {
//     console.error('Error confirming remittance:', error);
//     alert(`Error confirming remittance: ${error.message}`);
//   } finally {
//     setConfirmingIds(prev => {
//       const newSet = new Set(prev);
//       newSet.delete(`${remittanceIdStr}_${userIdStr}`);
//       return newSet;
//     });
//   }
// };

// const refreshData = async () => {
//   setRemittances([]);
//   setRemittanceUserData({});
//   setExpandedRemittances(new Set());
//   setShowPendingOnly(false);
//     setPendingRemittanceIds(new Set());
//     setPendingRemittancesCount(0);
//   await fetchRemittances();
//   await fetchUnconfirmedStatus();
// };

//   const exportData = () => {
//     const csvData = [];

//     // Add headers
//     csvData.push(['Remittance ID', 'Payment Date', 'Status', 'Generated COD', 'Net Payable', 'Orders Count', 'Brand Name', 'User ID', 'User Amount', 'User Orders', 'Confirmed']);

//     // Add data
//     sortedRemittances.forEach(remittance => {
//       const userData = remittanceUserData[remittance.id];
//       if (userData && userData.userSummaries) {
//         userData.userSummaries.forEach(user => {
//           csvData.push([
//             remittance.id,
//             remittance.paymentDate,
//             remittance.paymentStatus,
//             remittance.generatedCod,
//             remittance.netPayableAmount,
//             remittance.ordersCount,
//             user.name,
//             user.userId,
//             user.totalAmount,
//             user.orderCount,
//             user.confirmed ? 'Yes' : 'No'
//           ]);
//         });
//       } else {
//         csvData.push([
//           remittance.id,
//           remittance.paymentDate,
//           remittance.paymentStatus,
//           remittance.generatedCod,
//           remittance.netPayableAmount,
//           remittance.ordersCount,
//           '', '', '', '', ''
//         ]);
//       }
//     });

//     const csvContent = csvData.map(row => row.join(',')).join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = 'cod-remittance-data.csv';
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   // Calculate totals
//   const totalRemittances = sortedRemittances.length;
//   const totalGeneratedCod = sortedRemittances.reduce((sum, r) => sum + r.generatedCod, 0);
//   const totalNetPayable = sortedRemittances.reduce((sum, r) => sum + r.netPayableAmount, 0);
//   const paidCount = sortedRemittances.filter(r => r.paymentStatus === 'PAID').length;

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <RefreshCw className="h-8 w-8 animate-spin text-blue-600 mx-auto mb-4" />
//           <p className="text-gray-600">Loading COD remittances...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
//             {error}
//           </div>
//           <button 
//             onClick={refreshData}
//             className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
//           >
//             Try Again
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
//           <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
//                 <DollarSign className="h-6 w-6 text-green-600" />
//                 COD Remittance Management
//               </h1>
//               <p className="text-gray-600 mt-1">View remittances and manage user confirmations</p>
//             </div>

//             <div className="flex flex-col sm:flex-row gap-3">
//               <button
//                 onClick={refreshData}
//                 className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
//               >
//                 <RefreshCw className="h-4 w-4" />
//                 Refresh
//               </button>
//               <button
//                 onClick={exportData}
//                 className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
//               >
//                 <Download className="h-4 w-4" />
//                 Export CSV
//               </button>
//             </div>
//           </div>

//           {/* Summary Cards */}
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6">
//             <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
//               <div className="flex items-center gap-3">
//                 <Package className="h-8 w-8 text-blue-600" />
//                 <div>
//                   <p className="text-sm text-blue-600 font-medium">Total Remittances</p>
//                   <p className="text-2xl font-bold text-blue-800">{totalRemittances}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="bg-green-50 p-4 rounded-lg border border-green-200">
//               <div className="flex items-center gap-3">
//                 <DollarSign className="h-8 w-8 text-green-600" />
//                 <div>
//                   <p className="text-sm text-green-600 font-medium">Total Generated COD</p>
//                   <p className="text-2xl font-bold text-green-800">{formatCurrency(totalGeneratedCod)}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
//               <div className="flex items-center gap-3">
//                 <Calendar className="h-8 w-8 text-purple-600" />
//                 <div>
//                   <p className="text-sm text-purple-600 font-medium">Net Payable</p>
//                   <p className="text-2xl font-bold text-purple-800">{formatCurrency(totalNetPayable)}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
//               <div className="flex items-center gap-3">
//                 <CheckCircle className="h-8 w-8 text-orange-600" />
//                 <div>
//                   <p className="text-sm text-orange-600 font-medium">Paid Remittances</p>
//                   <p className="text-2xl font-bold text-orange-800">{paidCount}/{totalRemittances}</p>
//                 </div>
//               </div>
//             </div>

// <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
//   <div className="flex items-center gap-3">
//     <Eye className="h-8 w-8 text-indigo-600" />
//     <div className="flex-1">
//       <p className="text-sm text-indigo-600 font-medium">Pending Confirmations</p>
//       <div className="flex items-center gap-2">
//         {checkingPendingRemittances ? (
//           <>
//             <RefreshCw className="h-5 w-5 animate-spin text-indigo-600" />
//             <p className="text-sm text-indigo-600">Checking...</p>
//           </>
//         ) : (
//           <>
//             <p className="text-2xl font-bold text-indigo-800">{pendingRemittancesCount}</p>
//             <button
//               onClick={() => setShowPendingOnly(!showPendingOnly)}
//               className={`px-2 py-1 text-xs rounded ${
//                 showPendingOnly 
//                   ? 'bg-indigo-600 text-white' 
//                   : 'bg-indigo-200 text-indigo-700 hover:bg-indigo-300'
//               }`}
//             >
//               {showPendingOnly ? 'Show All' : 'Show'}
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   </div>
// </div>

//           </div>
//         </div>




//         {/* Search and Filters */}
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
//           <div className="relative">
//             <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
//             <input
//               type="text"
//               placeholder="Search by remittance ID, payment date, or status..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//             />
//           </div>
//         </div>

//         {/* Remittances Table */}
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gray-50 border-b border-gray-200">
//                 <tr>
//                   <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
//                     Expand
//                   </th>
//                   <th 
//                     className="px-6 py-4 text-left text-sm font-semibold text-gray-900 cursor-pointer hover:bg-gray-100 transition-colors"
//                     onClick={() => handleSort('id')}
//                   >
//                     <div className="flex items-center gap-2">
//                       Remittance ID
//                       {sortConfig.key === 'id' && (
//                         <span className="text-blue-600">
//                           {sortConfig.direction === 'asc' ? '↑' : '↓'}
//                         </span>
//                       )}
//                     </div>
//                   </th>
//                   <th 
//                     className="px-6 py-4 text-left text-sm font-semibold text-gray-900 cursor-pointer hover:bg-gray-100 transition-colors"
//                     onClick={() => handleSort('paymentDate')}
//                   >
//                     <div className="flex items-center gap-2">
//                       Payment Date
//                       {sortConfig.key === 'paymentDate' && (
//                         <span className="text-blue-600">
//                           {sortConfig.direction === 'asc' ? '↑' : '↓'}
//                         </span>
//                       )}
//                     </div>
//                   </th>
//                   <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
//                     Status
//                   </th>
//                   <th 
//                     className="px-6 py-4 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-gray-100 transition-colors"
//                     onClick={() => handleSort('generatedCod')}
//                   >
//                     <div className="flex items-center justify-end gap-2">
//                       Generated COD
//                       {sortConfig.key === 'generatedCod' && (
//                         <span className="text-blue-600">
//                           {sortConfig.direction === 'asc' ? '↑' : '↓'}
//                         </span>
//                       )}
//                     </div>
//                   </th>
//                   <th 
//                     className="px-6 py-4 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-gray-100 transition-colors"
//                     onClick={() => handleSort('netPayableAmount')}
//                   >
//                     <div className="flex items-center justify-end gap-2">
//                       Net Payable
//                       {sortConfig.key === 'netPayableAmount' && (
//                         <span className="text-blue-600">
//                           {sortConfig.direction === 'asc' ? '↑' : '↓'}
//                         </span>
//                       )}
//                     </div>
//                   </th>
//                   <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
//                     Orders
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {sortedRemittances.map((remittance) => (
//                   <React.Fragment key={remittance.id}>
//                     {/* Main Remittance Row */}
//                     <tr className="hover:bg-gray-50 transition-colors">
//                       <td className="px-6 py-4 whitespace-nowrap">
//                         <button
//                           onClick={() => toggleRemittanceExpansion(remittance.id)}
//                           className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-200 transition-colors"
//                         >
//                           {loadingRemittances.has(remittance.id) ? (
//                             <RefreshCw className="h-4 w-4 animate-spin text-blue-600" />
//                           ) : expandedRemittances.has(remittance.id) ? (
//                             <ChevronDown className="h-4 w-4 text-gray-600" />
//                           ) : (
//                             <ChevronRight className="h-4 w-4 text-gray-600" />
//                           )}
//                         </button>
//                       </td>
//                    <td className="px-6 py-4 whitespace-nowrap">
//   <div className="flex items-center gap-2">
//     <div className="text-sm font-mono text-gray-900 bg-gray-100 px-2 py-1 rounded">
//       {remittance.id}
//     </div>
//     {unconfirmedStatus[remittance.id]?.hasUnconfirmed && (
//       <div className="relative group">
//         <div className="h-2 w-2 bg-red-500 rounded-full animate-pulse"></div>
//         <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded py-1 px-2 whitespace-nowrap z-10">
//           {unconfirmedStatus[remittance.id].unconfirmedCount} unconfirmed brand{unconfirmedStatus[remittance.id].unconfirmedCount > 1 ? 's' : ''}
//         </div>
//       </div>
//     )}
//   </div>
// </td>
//                       <td className="px-6 py-4 whitespace-nowrap">
//                         <div className="flex items-center gap-2">
//                           <Calendar className="h-4 w-4 text-gray-400" />
//                           <span className="text-sm text-gray-900">
//                             {formatDate(remittance.paymentDate)}
//                           </span>
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-center">
//                         <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
//                           remittance.paymentStatus === 'PAID' 
//                             ? 'bg-green-100 text-green-800' 
//                             : 'bg-yellow-100 text-yellow-800'
//                         }`}>
//                           {remittance.paymentStatus}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-right">
//                         <span className="text-lg font-semibold text-blue-600">
//                           {formatCurrency(remittance.generatedCod)}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-right">
//                         <span className="text-lg font-semibold text-green-600">
//                           {formatCurrency(remittance.netPayableAmount)}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-center">
//                         <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                           {remittance.ordersCount} orders
//                         </span>
//                       </td>
//                     </tr>

//                     {/* Expanded User Details */}
//                     {expandedRemittances.has(remittance.id) && (
//                       <tr>
//                         <td colSpan="7" className="px-6 py-4 bg-gray-50">
//                           {loadingRemittances.has(remittance.id) ? (
//                             <div className="flex items-center justify-center py-8">
//                               <RefreshCw className="h-6 w-6 animate-spin text-blue-600 mr-3" />
//                               <span className="text-gray-600">Loading user details...</span>
//                             </div>
//                           ) : remittanceUserData[remittance.id] ? (
//                             <div className="space-y-4">
//                               <div className="flex items-center justify-between">
//                                 <h4 className="text-lg font-semibold text-gray-900">
//                                   User Summary ({remittanceUserData[remittance.id].summary.totalUsers} users)
//                                 </h4>
//                                 <div className="text-sm text-gray-600">
//                                   Total Amount: <span className="font-semibold text-green-600">
//                                     {formatCurrency(remittanceUserData[remittance.id].summary.totalAmount)}
//                                   </span>
//                                 </div>
//                               </div>

//                               {remittanceUserData[remittance.id].userSummaries.length > 0 ? (
//                                 <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
//                                   <table className="w-full">
//                                     <thead className="bg-gray-100">
//                                       <tr>
//                                         <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">Brand Name</th>
//                                         <th className="px-4 py-3 text-right text-sm font-medium text-gray-700">Amount</th>
//                                         <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">Orders</th>
//                                         <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">Action</th>
//                                       </tr>
//                                     </thead>
//                                     <tbody className="divide-y divide-gray-200">
//                                       {remittanceUserData[remittance.id].userSummaries.map((user) => (
//                                         <tr key={user.userId} className="hover:bg-gray-50">
//                                           <td className="px-4 py-3">
//                                             <div className="flex items-center">
//                                               <div className="h-8 w-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold text-xs mr-3">
//                                                 {user.name.charAt(0).toUpperCase()}
//                                               </div>
//                                               <div>
//                                                 <div className="text-sm font-medium text-gray-900">{user.name}</div>
//                                                 <div className="text-xs text-gray-500">ID: {user.userId}</div>
//                                               </div>
//                                             </div>
//                                           </td>
//                                           <td className="px-4 py-3 text-right">
//                                             <span className="text-sm font-semibold text-green-600">
//                                               {formatCurrency(user.totalAmount)}
//                                             </span>
//                                           </td>
//                                           <td className="px-4 py-3 text-center">
//                                             <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                                               {user.orderCount}
//                                             </span>
//                                           </td>
//                                           <td className="px-4 py-3 text-center">
//                                             {user.confirmed ? (
//                                               <div className="flex items-center justify-center gap-1 text-green-600">
//                                                 <CheckCircle className="h-4 w-4" />
//                                                 <span className="text-xs font-medium">Confirmed</span>
//                                               </div>
//                                             ) : (
//                                               <button
//                                                 onClick={() => handleConfirm(remittance.id, user.userId)}
//                                                 disabled={confirmingIds.has(`${remittance.id}_${user.userId}`) || remittance.paymentStatus !== 'PAID'}
//                                                 className={`flex items-center justify-center gap-1 px-3 py-1 rounded-lg text-xs font-medium transition-all ${
//                                                   remittance.paymentStatus !== 'PAID'
//                                                     ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
//                                                     : confirmingIds.has(`${remittance.id}_${user.userId}`)
//                                                     ? 'bg-blue-100 text-blue-600 cursor-not-allowed'
//                                                     : 'bg-blue-600 text-white hover:bg-blue-700'
//                                                 }`}
//                                               >
//                                                 {confirmingIds.has(`${remittance.id}_${user.userId}`) ? (
//                                                   <>
//                                                     <RefreshCw className="h-3 w-3 animate-spin" />
//                                                     Confirming...
//                                                   </>
//                                                 ) : (
//                                                   <>
//                                                     <Check className="h-3 w-3" />
//                                                     Confirm
//                                                   </>
//                                                 )}
//                                               </button>
//                                             )}
//                                           </td>
//                                         </tr>
//                                       ))}
//                                     </tbody>
//                                   </table>
//                                 </div>
//                               ) : (
//                                 <div className="text-center py-6 text-gray-500">
//                                   No users found for this remittance
//                                 </div>
//                               )}
//                             </div>
//                           ) : (
//                             <div className="text-center py-6 text-red-500">
//                               Failed to load user details
//                             </div>
//                           )}
//                         </td>
//                       </tr>
//                     )}
//                   </React.Fragment>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {sortedRemittances.length === 0 && (
//             <div className="text-center py-12">
//               <Search className="h-12 w-12 text-gray-400 mx-auto mb-4" />
//               <p className="text-gray-500 text-lg">No remittances found</p>
//               <p className="text-gray-400 text-sm">Try adjusting your search criteria</p>
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mt-6">
//           <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-600">
//             <div>
//               Showing {sortedRemittances.length} of {remittances.length} remittances
//             </div>
//             <div>
//               Last updated: {new Date().toLocaleString('en-IN')}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CODRemittanceTable;



import React, { useState, useEffect } from 'react';
import { Search, Calendar, DollarSign, Users, RefreshCw, Download, Check, CheckCircle, ChevronDown, ChevronRight, Eye, Package } from 'lucide-react';
import { db } from '../firebase';
import { doc, setDoc, getDoc, collection, serverTimestamp, Timestamp } from 'firebase/firestore';

const CODRemittanceTable = () => {
  const [remittances, setRemittances] = useState([]);
  const [expandedRemittances, setExpandedRemittances] = useState(new Set());
  const [remittanceUserData, setRemittanceUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingRemittances, setLoadingRemittances] = useState(new Set());
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'paymentDate', direction: 'desc' });
  const [confirmingIds, setConfirmingIds] = useState(new Set());
  const [showPendingOnly, setShowPendingOnly] = useState(false);
  const [pendingRemittancesCount, setPendingRemittancesCount] = useState(0);
  const [pendingRemittanceIds, setPendingRemittanceIds] = useState(new Set());
  const [syncing, setSyncing] = useState(false);
  const [syncStatus, setSyncStatus] = useState(null);
  const [checkingPendingRemittances, setCheckingPendingRemittances] = useState(false);
  const [pendingCheckProgress, setPendingCheckProgress] = useState({ current: 0, total: 0 });

  const API_BASE_URL = 'https://ufb-1.onrender.com/codRemittance';

  // Helper function to format date as string (YYYY-MM-DD)
  const formatDateString = (dateInput) => {
    if (dateInput === null || dateInput === undefined) {
      return '';
    }

    let dateStr;
    try {
      dateStr = String(dateInput);
    } catch (e) {
      console.error('Error converting to string:', e);
      return '';
    }

    try {
      let parts = [];
      let currentPart = '';

      for (let i = 0; i < dateStr.length; i++) {
        const char = dateStr.charAt(i);
        if (char === ' ') {
          if (currentPart.length > 0) {
            parts.push(currentPart);
            currentPart = '';
          }
        } else {
          currentPart += char;
        }
      }
      if (currentPart.length > 0) {
        parts.push(currentPart);
      }

      if (parts.length === 3) {
        const dayStr = parts[0];
        const monthStr = parts[1];
        const yearStr = parts[2];

        const day = parseInt(dayStr, 10);
        const year = parseInt(yearStr, 10);

        let monthNum = 0;
        if (monthStr === 'Jan') monthNum = 1;
        else if (monthStr === 'Feb') monthNum = 2;
        else if (monthStr === 'Mar') monthNum = 3;
        else if (monthStr === 'Apr') monthNum = 4;
        else if (monthStr === 'May') monthNum = 5;
        else if (monthStr === 'Jun') monthNum = 6;
        else if (monthStr === 'Jul') monthNum = 7;
        else if (monthStr === 'Aug') monthNum = 8;
        else if (monthStr === 'Sep') monthNum = 9;
        else if (monthStr === 'Oct') monthNum = 10;
        else if (monthStr === 'Nov') monthNum = 11;
        else if (monthStr === 'Dec') monthNum = 12;

        if (monthNum > 0 && day > 0 && day <= 31 && year > 1900 && year < 2100) {
          const yearPadded = year.toString();
          const monthPadded = (monthNum < 10) ? '0' + monthNum.toString() : monthNum.toString();
          const dayPadded = (day < 10) ? '0' + day.toString() : day.toString();

          return yearPadded + '-' + monthPadded + '-' + dayPadded;
        }
      }

      const cleanDateStr = dateStr.trim();
      const testDate = new Date(cleanDateStr);

      if (!isNaN(testDate.getTime())) {
        const isoString = testDate.toISOString();
        let datePart = '';
        for (let i = 0; i < 10; i++) {
          datePart += isoString.charAt(i);
        }
        return datePart;
      }

    } catch (error) {
      console.error('Error in formatDateString:', error, 'Input was:', dateInput);
    }

    return '';
  };

  const convertToTimestamp = (dateInput) => {
    if (dateInput === null || dateInput === undefined) {
      return null;
    }

    try {
      if (typeof dateInput === 'object' && dateInput !== null &&
        typeof dateInput.seconds === 'number') {
        return dateInput;
      }

      if (dateInput instanceof Date && !isNaN(dateInput.getTime())) {
        return Timestamp.fromDate(dateInput);
      }

      const dateStr = String(dateInput);
      let parts = [];
      let currentPart = '';

      for (let i = 0; i < dateStr.length; i++) {
        const char = dateStr.charAt(i);
        if (char === ' ') {
          if (currentPart.length > 0) {
            parts.push(currentPart);
            currentPart = '';
          }
        } else {
          currentPart += char;
        }
      }
      if (currentPart.length > 0) {
        parts.push(currentPart);
      }

      if (parts.length === 3) {
        const dayStr = parts[0];
        const monthStr = parts[1];
        const yearStr = parts[2];

        const day = parseInt(dayStr, 10);
        const year = parseInt(yearStr, 10);

        let monthNum = -1;
        if (monthStr === 'Jan') monthNum = 0;
        else if (monthStr === 'Feb') monthNum = 1;
        else if (monthStr === 'Mar') monthNum = 2;
        else if (monthStr === 'Apr') monthNum = 3;
        else if (monthStr === 'May') monthNum = 4;
        else if (monthStr === 'Jun') monthNum = 5;
        else if (monthStr === 'Jul') monthNum = 6;
        else if (monthStr === 'Aug') monthNum = 7;
        else if (monthStr === 'Sep') monthNum = 8;
        else if (monthStr === 'Oct') monthNum = 9;
        else if (monthStr === 'Nov') monthNum = 10;
        else if (monthStr === 'Dec') monthNum = 11;

        if (monthNum >= 0 && day > 0 && day <= 31 && year > 1900 && year < 2100) {
          const date = new Date(year, monthNum, day);
          if (!isNaN(date.getTime())) {
            return Timestamp.fromDate(date);
          }
        }
      }

      const testDate = new Date(dateStr.trim());
      if (!isNaN(testDate.getTime())) {
        return Timestamp.fromDate(testDate);
      }

    } catch (error) {
      console.error('Error in convertToTimestamp:', error, 'Input was:', dateInput);
    }

    return null;
  };

  // Check Firestore confirmation status for users in a remittance
  const checkFirestoreConfirmationStatus = async (userSummaries, remittanceId) => {
    console.log('Checking Firestore confirmation status for remittance', remittanceId);

    const updatedUsers = await Promise.all(
      userSummaries.map(async (user) => {
        try {
          const userIdStr = String(user.userId);
          const remittanceIdStr = String(remittanceId);

          const codSummaryRef = doc(db, 'users', userIdStr, 'codSummary', remittanceIdStr);
          const codSummaryDoc = await getDoc(codSummaryRef);

          if (codSummaryDoc.exists()) {
            const data = codSummaryDoc.data();
            const isConfirmed = data.status === 'confirmed';
            return { ...user, confirmed: isConfirmed };
          } else {
            return { ...user, confirmed: false };
          }
        } catch (error) {
          console.error(`Error checking Firestore status for user ${user.userId}:`, error);
          return { ...user, confirmed: false };
        }
      })
    );

    return updatedUsers;
  };

  // NEW: Sync remittances from Shipmozo to database
  const syncRemittances = async () => {
    setSyncing(true);
    setSyncStatus(null);

    try {
      const response = await fetch(`${API_BASE_URL}/api/sync-remittances`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        setSyncStatus({
          success: true,
          stored: data.data.stored.length,
          updated: data.data.updated.length,
          errors: data.data.errors.length
        });

        // Refresh the remittances list after sync
        await fetchRemittances();
      } else {
        throw new Error(data.message || 'Sync failed');
      }
    } catch (err) {
      setSyncStatus({
        success: false,
        message: err.message
      });
      console.error('Error syncing remittances:', err);
    } finally {
      setSyncing(false);
    }
  };

  // UPDATED: Fetch remittances from database instead of Shipmozo API
  const fetchRemittances = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/cod-remittances-paginated`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && data.data && data.data.remittances) {
        setRemittances(data.data.remittances);
        setError(null);
      } else {
        throw new Error(data.message || 'Invalid API response format');
      }
    } catch (err) {
      setError(`Failed to fetch remittances: ${err.message}`);
      console.error('Error fetching remittances:', err);
      setRemittances([]);
    } finally {
      setLoading(false);
    }
  };

  // Update the Calculate pending remittances useEffect
  useEffect(() => {
    const calculatePendingRemittances = () => {
      let pendingCount = 0;
      const pendingIds = new Set();

      remittances.forEach(remittance => {
        const userData = remittanceUserData[remittance.id];
        if (userData && userData.userSummaries) {
          const hasUnconfirmed = userData.userSummaries.some(user => !user.confirmed);
          if (hasUnconfirmed) {
            pendingCount++;
            pendingIds.add(remittance.id);
          }
        }
      });

      setPendingRemittancesCount(pendingCount);
      setPendingRemittanceIds(pendingIds);
    };

    calculatePendingRemittances();
  }, [remittances, remittanceUserData]); // Add remittanceUserData as dependency

  // Update the auto-fetch useEffect
  useEffect(() => {
    const checkPendingRemittancesOnLoad = async () => {
      if (remittances.length === 0) return;

      // Check remittances that we haven't checked yet
      const uncheckedRemittances = remittances.filter(r => !remittanceUserData[r.id]);

      if (uncheckedRemittances.length === 0) return;

      setCheckingPendingRemittances(true);
      setPendingCheckProgress({ current: 0, total: uncheckedRemittances.length });

      console.log(`Checking ${uncheckedRemittances.length} remittances for pending confirmations...`);

      for (let i = 0; i < uncheckedRemittances.length; i++) {
        const remittance = uncheckedRemittances[i];

        try {
          await fetchRemittanceUserSummary(remittance.id, true);
          setPendingCheckProgress({ current: i + 1, total: uncheckedRemittances.length });

          // Small delay to avoid overwhelming the API
          await new Promise(resolve => setTimeout(resolve, 100));
        } catch (error) {
          console.error(`Error checking remittance ${remittance.id}:`, error);
          setPendingCheckProgress({ current: i + 1, total: uncheckedRemittances.length });
        }
      }

      setCheckingPendingRemittances(false);
      console.log('Finished checking all remittances');
    };

    // Run when remittances are loaded and we don't have data yet
    const shouldCheck = remittances.length > 0 &&
      !checkingPendingRemittances &&
      remittances.some(r => !remittanceUserData[r.id]);

    if (shouldCheck) {
      checkPendingRemittancesOnLoad();
    }
  }, [remittances, remittanceUserData]); // Add remittanceUserData as dependency

  const fetchRemittanceUserSummary = async (remittanceId, silent = false) => {
    if (remittanceUserData[remittanceId] && !silent) {
      return;
    }

    if (!silent) {
      setLoadingRemittances(prev => new Set([...prev, remittanceId]));
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/cod-remittance/${remittanceId}/user-summary`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && data.data) {
        const usersWithConfirmation = await checkFirestoreConfirmationStatus(
          data.data.userSummaries,
          remittanceId
        );

        setRemittanceUserData(prev => ({
          ...prev,
          [remittanceId]: {
            ...data.data,
            userSummaries: usersWithConfirmation,
            source: data.source
          }
        }));
      } else {
        throw new Error(data.message || 'Invalid API response format');
      }
    } catch (err) {
      console.error(`Error fetching user summary for remittance ${remittanceId}:`, err);
      setRemittanceUserData(prev => ({
        ...prev,
        [remittanceId]: { userSummaries: [], summary: { totalUsers: 0, totalAmount: 0 } }
      }));
    } finally {
      if (!silent) {
        setLoadingRemittances(prev => {
          const newSet = new Set(prev);
          newSet.delete(remittanceId);
          return newSet;
        });
      }
    }
  };

  const toggleRemittanceExpansion = async (remittanceId) => {
    const isExpanded = expandedRemittances.has(remittanceId);

    if (isExpanded) {
      setExpandedRemittances(prev => {
        const newSet = new Set(prev);
        newSet.delete(remittanceId);
        return newSet;
      });
    } else {
      setExpandedRemittances(prev => new Set([...prev, remittanceId]));
      await fetchRemittanceUserSummary(remittanceId);
    }
  };

  // Initial data fetch
  useEffect(() => {
    fetchRemittances();
  }, []);

  const filteredRemittances = remittances.filter(remittance => {
    const matchesSearch = remittance.id.toString().includes(searchTerm) ||
      remittance.paymentDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
      remittance.paymentStatus.toLowerCase().includes(searchTerm.toLowerCase());

    if (!matchesSearch) return false;

    if (showPendingOnly) {
      return pendingRemittanceIds.has(remittance.id);
    }

    return true;
  });

  const sortedRemittances = [...filteredRemittances].sort((a, b) => {
    if (sortConfig.key === 'netPayableAmount' || sortConfig.key === 'generatedCod') {
      return sortConfig.direction === 'asc'
        ? a[sortConfig.key] - b[sortConfig.key]
        : b[sortConfig.key] - a[sortConfig.key];
    }
    if (sortConfig.key === 'paymentDate') {
      return sortConfig.direction === 'asc'
        ? new Date(a.paymentDate) - new Date(b.paymentDate)
        : new Date(b.paymentDate) - new Date(a.paymentDate);
    }
    if (sortConfig.key === 'id') {
      return sortConfig.direction === 'asc'
        ? a.id - b.id
        : b.id - a.id;
    }
    return 0;
  });

  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'desc' ? 'asc' : 'desc'
    }));
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (dateString === '--' || !dateString) return dateString;
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };



  const handleConfirm = async (remittanceId, userId) => {
    const userIdStr = String(userId);
    const remittanceIdStr = String(remittanceId);

    setConfirmingIds(prev => new Set([...prev, `${remittanceIdStr}_${userIdStr}`]));

    try {
      const remittanceData = remittanceUserData[remittanceIdStr];
      if (!remittanceData) {
        throw new Error('Remittance data not found');
      }

      const userRemittanceData = remittanceData.userSummaries.find(user =>
        String(user.userId) === userIdStr
      );

      if (!userRemittanceData) {
        throw new Error('User remittance data not found');
      }

      if (!userRemittanceData.orders || userRemittanceData.orders.length === 0) {
        throw new Error('No orders found for this remittance');
      }

      // Get payment date from remittanceInfo instead of userRemittanceData
      let paymentDate = remittanceData.remittanceInfo?.paymentDate ||
        remittanceData.paymentDate ||
        userRemittanceData.paymentDate;

      // If payment date is missing or '--' (typical for pending remittances), default to current date
      if (!paymentDate || paymentDate === '--') {
        paymentDate = new Date();
      }

      let formattedDate = formatDateString(paymentDate);
      if (!formattedDate) {
        formattedDate = new Date().toISOString().split('T')[0];
      }

      const orderTimestamp = convertToTimestamp(paymentDate) || Timestamp.now();

      // 1. Store in codSummary collection
      const codSummaryRef = doc(db, 'users', userIdStr, 'codSummary', remittanceIdStr);
      const codSummaryData = {
        date: formattedDate,
        lastUpdated: serverTimestamp(),
        orderCount: userRemittanceData.orderCount,
        orders: userRemittanceData.orders.map(order => String(order.referenceId || order.orderId)),
        status: "confirmed",
        timestamp: serverTimestamp(),
        totalAmount: userRemittanceData.totalAmount
      };

      await setDoc(codSummaryRef, codSummaryData);

      // 2. Store each order in codRecords collection
      const codRecordsPromises = userRemittanceData.orders.map(async (order) => {
        if (!order.referenceId && !order.orderId) {
          console.warn('Order missing both referenceId and orderId:', order);
          return Promise.resolve();
        }

        const orderIdStr = String(order.referenceId || order.orderId);
        const codRecordRef = doc(db, 'users', userIdStr, 'codRecords', orderIdStr);
        const codRecordData = {
          amount: parseFloat(order.codAmount) || 0,
          date: formattedDate,
          orderId: String(order.referenceId),
          remittanceId: remittanceIdStr,
          timestamp: orderTimestamp || serverTimestamp()
        };

        return setDoc(codRecordRef, codRecordData);
      });

      await Promise.all(codRecordsPromises);

      // 3. Update each order document with COD remittance info
      const orderUpdatePromises = userRemittanceData.orders.map(async (order) => {
        if (!order.referenceId && !order.orderId) {
          return Promise.resolve();
        }

        const orderIdStr = String(order.referenceId || order.orderId);
        const orderRef = doc(db, 'users', userIdStr, 'orders', orderIdStr);

        const orderUpdateData = {
          codRemittance: true,
          codRemittanceId: remittanceIdStr,
          codRemittanceDate: formattedDate,
          codRemittanceAmount: parseFloat(order.codAmount) || 0,
          codRemittanceConfirmedAt: serverTimestamp()
        };

        return setDoc(orderRef, orderUpdateData, { merge: true });
      });

      await Promise.all(orderUpdatePromises);

      // 4. Update confirmation status in database
      await fetch(`${API_BASE_URL}/api/cod-remittance/${remittanceIdStr}/confirm/${userIdStr}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      // Update local state
      setRemittanceUserData(prev => ({
        ...prev,
        [remittanceIdStr]: {
          ...prev[remittanceIdStr],
          userSummaries: prev[remittanceIdStr].userSummaries.map(user =>
            String(user.userId) === userIdStr
              ? { ...user, confirmed: true }
              : user
          )
        }
      }));

      console.log('Successfully confirmed remittance');

    } catch (error) {
      console.error('Error confirming remittance:', error);
      alert(`Error confirming remittance: ${error.message}`);
    } finally {
      setConfirmingIds(prev => {
        const newSet = new Set(prev);
        newSet.delete(`${remittanceIdStr}_${userIdStr}`);
        return newSet;
      });
    }
  };

  const refreshData = async () => {
    setRemittances([]);
    setRemittanceUserData({});
    setExpandedRemittances(new Set());
    setShowPendingOnly(false);
    setPendingRemittanceIds(new Set());
    setPendingRemittancesCount(0);
    await fetchRemittances();
  };

  const exportData = () => {
    const csvData = [];

    csvData.push(['Remittance ID', 'Payment Date', 'Status', 'Generated COD', 'Net Payable', 'Orders Count', 'Brand Name', 'User ID', 'User Amount', 'User Orders', 'Confirmed']);

    sortedRemittances.forEach(remittance => {
      const userData = remittanceUserData[remittance.id];
      if (userData && userData.userSummaries) {
        userData.userSummaries.forEach(user => {
          csvData.push([
            remittance.id,
            remittance.paymentDate,
            remittance.paymentStatus,
            remittance.generatedCod,
            remittance.netPayableAmount,
            remittance.ordersCount,
            user.name,
            user.userId,
            user.totalAmount,
            user.orderCount,
            user.confirmed ? 'Yes' : 'No'
          ]);
        });
      } else {
        csvData.push([
          remittance.id,
          remittance.paymentDate,
          remittance.paymentStatus,
          remittance.generatedCod,
          remittance.netPayableAmount,
          remittance.ordersCount,
          '', '', '', '', ''
        ]);
      }
    });

    const csvContent = csvData.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'cod-remittance-data.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const totalRemittances = sortedRemittances.length;
  const totalGeneratedCod = sortedRemittances.reduce((sum, r) => sum + r.generatedCod, 0);
  const totalNetPayable = sortedRemittances.reduce((sum, r) => sum + r.netPayableAmount, 0);
  const paidCount = sortedRemittances.filter(r => r.paymentStatus === 'PAID').length;

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <RefreshCw className="h-8 w-8 animate-spin text-blue-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading COD remittances...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
          <button
            onClick={refreshData}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                <DollarSign className="h-6 w-6 text-green-600" />
                COD Remittance Management
              </h1>
              <p className="text-gray-600 mt-1">View remittances and manage user confirmations</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={syncRemittances}
                disabled={syncing}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${syncing
                  ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
                  : 'bg-purple-600 text-white hover:bg-purple-700'
                  }`}
              >
                {syncing ? (
                  <>
                    <RefreshCw className="h-4 w-4 animate-spin" />
                    Syncing...
                  </>
                ) : (
                  <>

                    Sync from Shipmozo
                  </>
                )}
              </button>
              <button
                onClick={refreshData}
                className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
              >
                <RefreshCw className="h-4 w-4" />
                Refresh
              </button>
              <button
                onClick={exportData}
                className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                <Download className="h-4 w-4" />
                Export CSV
              </button>
            </div>
          </div>

          {/* Sync Status */}
          {syncStatus && (
            <div className={`mt-4 p-3 rounded-lg ${syncStatus.success ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
              }`}>
              {syncStatus.success ? (
                <p>
                  ✓ Sync completed: {syncStatus.stored} new remittances stored, {syncStatus.updated} updated
                  {syncStatus.errors > 0 && `, ${syncStatus.errors} errors`}
                </p>
              ) : (
                <p>✗ Sync failed: {syncStatus.message}</p>
              )}
            </div>
          )}

          {/* Loading Banner for Pending Check */}
          {checkingPendingRemittances && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <RefreshCw className="h-5 w-5 animate-spin text-blue-600" />
                  <div>
                    <p className="text-sm font-medium text-blue-900">
                      Checking pending confirmations...
                    </p>
                    <p className="text-xs text-blue-600">
                      Progress: {pendingCheckProgress.current} / {pendingCheckProgress.total} remittances
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-48 bg-blue-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                      style={{
                        width: `${pendingCheckProgress.total > 0 ? (pendingCheckProgress.current / pendingCheckProgress.total) * 100 : 0}%`
                      }}
                    />
                  </div>
                  <span className="text-xs text-blue-600 font-medium">
                    {pendingCheckProgress.total > 0 ? Math.round((pendingCheckProgress.current / pendingCheckProgress.total) * 100) : 0}%
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-6">
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <div className="flex items-center gap-3">
                <Package className="h-8 w-8 text-blue-600" />
                <div>
                  <p className="text-sm text-blue-600 font-medium">Total Remittances</p>
                  <p className="text-2xl font-bold text-blue-800">{totalRemittances}</p>
                </div>
              </div>
            </div>

            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
              <div className="flex items-center gap-3">
                <DollarSign className="h-8 w-8 text-green-600" />
                <div>
                  <p className="text-sm text-green-600 font-medium">Total Generated COD</p>
                  <p className="text-2xl font-bold text-green-800">{formatCurrency(totalGeneratedCod)}</p>
                </div>
              </div>
            </div>

            <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
              <div className="flex items-center gap-3">
                <Calendar className="h-8 w-8 text-purple-600" />
                <div>
                  <p className="text-sm text-purple-600 font-medium">Net Payable</p>
                  <p className="text-2xl font-bold text-purple-800">{formatCurrency(totalNetPayable)}</p>
                </div>
              </div>
            </div>

            <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
              <div className="flex items-center gap-3">
                <CheckCircle className="h-8 w-8 text-orange-600" />
                <div>
                  <p className="text-sm text-orange-600 font-medium">Paid Remittances</p>
                  <p className="text-2xl font-bold text-orange-800">{paidCount}/{totalRemittances}</p>
                </div>
              </div>
            </div>

            <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
              <div className="flex items-center gap-3">
                {checkingPendingRemittances ? (
                  <RefreshCw className="h-8 w-8 text-indigo-600 animate-spin" />
                ) : (
                  <Eye className="h-8 w-8 text-indigo-600" />
                )}
                <div className="flex-1">
                  <p className="text-sm text-indigo-600 font-medium">
                    {checkingPendingRemittances ? 'Checking...' : 'Pending Confirmations'}
                  </p>
                  <div className="flex items-center gap-2">
                    <p className="text-2xl font-bold text-indigo-800">
                      {checkingPendingRemittances ? (
                        <span className="text-lg">
                          {pendingCheckProgress.current}/{pendingCheckProgress.total}
                        </span>
                      ) : (
                        pendingRemittancesCount
                      )}
                    </p>
                    {!checkingPendingRemittances && (
                      <button
                        onClick={() => setShowPendingOnly(!showPendingOnly)}
                        className={`px-2 py-1 text-xs rounded ${showPendingOnly
                          ? 'bg-indigo-600 text-white'
                          : 'bg-indigo-200 text-indigo-700 hover:bg-indigo-300'
                          }`}
                      >
                        {showPendingOnly ? 'Show All' : 'Show'}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Search */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            <input
              type="text"
              placeholder="Search by remittance ID, payment date, or status..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        {/* Remittances Table */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                    Expand
                  </th>
                  <th
                    className="px-6 py-4 text-left text-sm font-semibold text-gray-900 cursor-pointer hover:bg-gray-100 transition-colors"
                    onClick={() => handleSort('id')}
                  >
                    <div className="flex items-center gap-2">
                      Remittance ID
                      {sortConfig.key === 'id' && (
                        <span className="text-blue-600">
                          {sortConfig.direction === 'asc' ? '↑' : '↓'}
                        </span>
                      )}
                    </div>
                  </th>
                  <th
                    className="px-6 py-4 text-left text-sm font-semibold text-gray-900 cursor-pointer hover:bg-gray-100 transition-colors"
                    onClick={() => handleSort('paymentDate')}
                  >
                    <div className="flex items-center gap-2">
                      Payment Date
                      {sortConfig.key === 'paymentDate' && (
                        <span className="text-blue-600">
                          {sortConfig.direction === 'asc' ? '↑' : '↓'}
                        </span>
                      )}
                    </div>
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                    Status
                  </th>
                  <th
                    className="px-6 py-4 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-gray-100 transition-colors"
                    onClick={() => handleSort('generatedCod')}
                  >
                    <div className="flex items-center justify-end gap-2">
                      Generated COD
                      {sortConfig.key === 'generatedCod' && (
                        <span className="text-blue-600">
                          {sortConfig.direction === 'asc' ? '↑' : '↓'}
                        </span>
                      )}
                    </div>
                  </th>
                  <th
                    className="px-6 py-4 text-right text-sm font-semibold text-gray-900 cursor-pointer hover:bg-gray-100 transition-colors"
                    onClick={() => handleSort('netPayableAmount')}
                  >
                    <div className="flex items-center justify-end gap-2">
                      Net Payable
                      {sortConfig.key === 'netPayableAmount' && (
                        <span className="text-blue-600">
                          {sortConfig.direction === 'asc' ? '↑' : '↓'}
                        </span>
                      )}
                    </div>
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                    Orders
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {sortedRemittances.map((remittance) => (
                  <React.Fragment key={remittance.id}>
                    <tr className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <button
                          onClick={() => toggleRemittanceExpansion(remittance.id)}
                          className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                          {loadingRemittances.has(remittance.id) ? (
                            <RefreshCw className="h-4 w-4 animate-spin text-blue-600" />
                          ) : expandedRemittances.has(remittance.id) ? (
                            <ChevronDown className="h-4 w-4 text-gray-600" />
                          ) : (
                            <ChevronRight className="h-4 w-4 text-gray-600" />
                          )}
                        </button>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          <div className="text-sm font-mono text-gray-900 bg-gray-100 px-2 py-1 rounded">
                            {remittance.id}
                          </div>
                          {pendingRemittanceIds.has(remittance.id) && (
                            <div className="relative group">
                              <div className="h-2 w-2 bg-red-500 rounded-full animate-pulse"></div>
                              <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded py-1 px-2 whitespace-nowrap z-10">
                                Pending confirmations
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          <Calendar className="h-4 w-4 text-gray-400" />
                          <span className="text-sm text-gray-900">
                            {formatDate(remittance.paymentDate)}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${remittance.paymentStatus === 'PAID'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-yellow-100 text-yellow-800'
                          }`}>
                          {remittance.paymentStatus}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right">
                        <span className="text-lg font-semibold text-blue-600">
                          {formatCurrency(remittance.generatedCod)}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right">
                        <span className="text-lg font-semibold text-green-600">
                          {formatCurrency(remittance.netPayableAmount)}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          {remittance.ordersCount} orders
                        </span>
                      </td>
                    </tr>

                    {/* Expanded User Details */}
                    {expandedRemittances.has(remittance.id) && (
                      <tr>
                        <td colSpan="7" className="px-6 py-4 bg-gray-50">
                          {loadingRemittances.has(remittance.id) ? (
                            <div className="flex items-center justify-center py-8">
                              <RefreshCw className="h-6 w-6 animate-spin text-blue-600 mr-3" />
                              <span className="text-gray-600">Loading user details...</span>
                            </div>
                          ) : remittanceUserData[remittance.id] ? (
                            <div className="space-y-4">
                              <div className="flex items-center justify-between">
                                <h4 className="text-lg font-semibold text-gray-900">
                                  User Summary ({remittanceUserData[remittance.id].summary?.totalUsers || remittanceUserData[remittance.id].userSummaries?.length || 0} users)
                                  {remittanceUserData[remittance.id].source === 'database' && (
                                    <span className="ml-2 text-xs text-green-600 font-normal">(from database)</span>
                                  )}
                                </h4>
                                <div className="text-sm text-gray-600">
                                  Total Amount: <span className="font-semibold text-green-600">
                                    {formatCurrency(remittanceUserData[remittance.id].summary?.totalAmount ||
                                      remittanceUserData[remittance.id].userSummaries?.reduce((sum, u) => sum + u.totalAmount, 0) || 0)}
                                  </span>
                                </div>
                              </div>

                              {remittanceUserData[remittance.id].userSummaries?.length > 0 ? (
                                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                                  <table className="w-full">
                                    <thead className="bg-gray-100">
                                      <tr>
                                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">Brand Name</th>
                                        <th className="px-4 py-3 text-right text-sm font-medium text-gray-700">Amount</th>
                                        <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">Orders</th>
                                        <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                      {remittanceUserData[remittance.id].userSummaries.map((user) => (
                                        <tr key={user.userId} className="hover:bg-gray-50">
                                          <td className="px-4 py-3">
                                            <div className="flex items-center">
                                              <div className="h-8 w-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold text-xs mr-3">
                                                {user.name.charAt(0).toUpperCase()}
                                              </div>
                                              <div>
                                                <div className="text-sm font-medium text-gray-900">{user.name}</div>
                                                <div className="text-xs text-gray-500">ID: {user.userId}</div>
                                              </div>
                                            </div>
                                          </td>
                                          <td className="px-4 py-3 text-right">
                                            <span className="text-sm font-semibold text-green-600">
                                              {formatCurrency(user.totalAmount)}
                                            </span>
                                          </td>
                                          <td className="px-4 py-3 text-center">
                                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                              {user.orderCount}
                                            </span>
                                          </td>
                                          <td className="px-4 py-3 text-center">
                                            {user.confirmed ? (
                                              <div className="flex items-center justify-center gap-1 text-green-600">
                                                <CheckCircle className="h-4 w-4" />
                                                <span className="text-xs font-medium">Confirmed</span>
                                              </div>
                                            ) : (
                                              <button
                                                onClick={() => handleConfirm(remittance.id, user.userId)}
                                                disabled={confirmingIds.has(`${remittance.id}_${user.userId}`)}
                                                className={`flex items-center justify-center gap-1 px-3 py-1 rounded-lg text-xs font-medium transition-all ${confirmingIds.has(`${remittance.id}_${user.userId}`)
                                                  ? 'bg-blue-100 text-blue-600 cursor-not-allowed'
                                                  : 'bg-blue-600 text-white hover:bg-blue-700'
                                                  }`}
                                              >
                                                {confirmingIds.has(`${remittance.id}_${user.userId}`) ? (
                                                  <>
                                                    <RefreshCw className="h-3 w-3 animate-spin" />
                                                    Confirming...
                                                  </>
                                                ) : (
                                                  <>
                                                    <Check className="h-3 w-3" />
                                                    Confirm
                                                  </>
                                                )}
                                              </button>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <div className="text-center py-6 text-gray-500">
                                  No users found for this remittance
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="text-center py-6 text-red-500">
                              Failed to load user details
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {sortedRemittances.length === 0 && (
            <div className="text-center py-12">
              <Search className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500 text-lg">No remittances found</p>
              <p className="text-gray-400 text-sm">Try adjusting your search criteria or sync from Shipmozo</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mt-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-600">
            <div>
              Showing {sortedRemittances.length} of {remittances.length} remittances
            </div>
            <div>
              Last updated: {new Date().toLocaleString('en-IN')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CODRemittanceTable;